import Loading from "components/Shared/Loading";
import React, { useEffect, useState } from "react";
import { STATUS } from "../../constants";
import { findIndex } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { getErrorReports } from "./errorReportSlice";

import ErrorList from "./components/ErrorList";
import ErrorPreviewComponent from "./components/ErrorPreviewComponent";
import ReportUploadComponent from "./components/ReportUploadComponent";
import FilesUploader from "components/FilesUploader";

const ErrorReportsInbox = () => {
  const dispatch = useDispatch();
  const { status, data: reports = [] } = useSelector(({ errorReports }) => errorReports);

  const [activeReport, setActiveReport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onUploadReportsFinished = async () => {
    dispatch(getErrorReports());
  };

  useEffect(() => {
    if ([STATUS.DEFAULT].includes(status)) {
      dispatch(getErrorReports());
    }
    setIsLoading(STATUS.LOADING === status);
  }, [dispatch, status]);

  useEffect(() => {
    if (!activeReport) {
      setActiveReport(reports[0] || null);
    } else {
      const activeIndex = findIndex(reports, { id: activeReport.id });
      if (activeIndex === -1) {
        setActiveReport(reports[0] || null);
      }
    }
  }, [activeReport, reports]);

  const report = activeReport || reports[0] || null;

  return isLoading ? (
    <Loading />
  ) : (
    <>
      <FilesUploader folder="report-upload-working" buttonTitle="Upload Reports" />
      <div className="columns">
        <div className="column is-3">
          <p className="menu-label">ABNORMAL REPORTS</p>
          <ErrorList
            reports={reports}
            activeReport={activeReport || reports[0] || null}
            onSelectReport={setActiveReport}
          />
        </div>
        {reports.length > 0 ? (
          <>
            <div className="column is-6">
              <p className="menu-label">FILE</p>
              <ErrorPreviewComponent key={report?.fileName} fileName={report?.fileName} />
            </div>
            <div className="column is-3">
              <p className="menu-label">CLIENT</p>
              <ReportUploadComponent file={report} onFinish={onUploadReportsFinished} />
            </div>
          </>
        ) : (
          <div>No Data</div>
        )}
      </div>
    </>
  );
};

export default ErrorReportsInbox;
